import { Link } from "@StarberryUtils";
import * as React from "react"
import HTMLReactParser from 'html-react-parser';
import ModalTiny from "react-bootstrap/Modal"
import { Container, Row, Col, Button } from "react-bootstrap"
import { useStaticQuery, graphql } from "gatsby";
import { useLocation } from "@reach/router"

import AgentImg from "../../images/member.jpg"
import Dacha from "../../images/dacha.png"
import { CloseIcon } from "../Icons/Icons";
import { GetURL } from "../common/site/functions";
import ContactForm from "../forms/contact-form";
import "./AreaGuideSidebar.scss"

const ServiceSidebar = (props) => {

	const location = useLocation();

	const data = useStaticQuery(graphql`
    query {
      glstrapi {
	    globalModule {
		  Service_Page_Sidebar_Content
	      Service_Page_Sidebar_CTA_1_Label 
	      Service_Page_Sidebar_CTA_1_Link {
	        id
	      }
		  Service_Page_Sidebar_CTA_2_Label 
	      Service_Page_Sidebar_CTA_2_Link {
	        id
	      }
	    }
      }
    }
  `);

	const content = data.glstrapi.globalModule

	let url1 = ''
	let url2 = ''
	if (content.Service_Page_Sidebar_CTA_1_Link) {
		url1 = GetURL(content.Service_Page_Sidebar_CTA_1_Link.id)
	}
	if (content.Service_Page_Sidebar_CTA_2_Link) {
		url2 = GetURL(content.Service_Page_Sidebar_CTA_2_Link.id)
	}

	var location_link = process.env.GATSBY_SITE_URL+location.pathname;

  	var whatsapp_no = props?.site?.Phone ? props.site.Phone.replace(/ /g,'').replace(/\+/g,'') : "9710505313003"

	var whatsapp_link = `https://wa.me/${whatsapp_no}?text=Hello!%20I%20want%20to%20know%20more%20about%20${location_link}`
	if(location.search.indexOf("utm_source") > 0){
		whatsapp_link = `https://wa.me/${whatsapp_no}?text=*G*%20Hello!%20I%20want%20to%20know%20more%20about%20${location_link}`
	}
	
	const [modalContactformOpen, setContactformOpen] = React.useState(false);

	const openContactformModal = () => {
		setContactformOpen(true);
	}
	const closeContactformModal = () => {
		setContactformOpen(false);
	}

	return (
		<React.Fragment>
			<div className={`area-guide-sidebar static-page-sidebar left-sticky ${props.class}`}>

				{HTMLReactParser(content.Service_Page_Sidebar_Content.replace(/<br\s*\/?>/gi, ''))}

				<div className=" d-xl-flex row-btn-group area-guide-sidebar-btn-group">
					{content.Service_Page_Sidebar_CTA_1_Label &&
						<Link to={`/${url1}`} className="btn btn-primary">{content.Service_Page_Sidebar_CTA_1_Label}</Link>
					}
					{content.Service_Page_Sidebar_CTA_2_Label &&
						<Link to={`/${url2}`} className="btn btn-outline btn-outline-dark">{content.Service_Page_Sidebar_CTA_2_Label}</Link>
					}

				</div>
				{/*
					props.peoples && props.peoples.map((people, i) => {
						return (<div className="agent-info" key={i}>
							{people.Tile_Image &&
								<div className="agent-pic">
									<img loading="lazy" src={people.Tile_Image.url} alt="" alt={`${people.Name} ${people.Designation} - Dacha`} />
								</div>
							}
							<div className="agent-info-details">
								<Link href={`/about-dacha/our-team/${people.URL}`}><strong className="agent-name">{people.Name}</strong></Link>
								<span className="agent-designation">{people.Designation}</span>
								<Link href={`tel:${people.Phone}`} className="agent-number"><i class="icon-people-phone"></i>{people.Phone}</Link>
							</div>
						</div>)
					})
				*/}
				{
					(props.site.Email || props.site.Phone) &&
					<div className="agent-info contact-info">
						<div className="agent-pic">
							<img loading="lazy" src={Dacha} alt={`Dacha Logo`} />
						</div>
						<div className="agent-info-details">
							{props.site.Phone ?
								<Link href={`tel:${props.site.Phone}`} className="agent-number"><i class="icon-people-phone"></i>{props.site.Phone}</Link>
								:
								<Link href={`tel:+971 4 423 2006`} className="agent-number"><i class="icon-people-phone"></i>+971 4 423 2006</Link>
							}
							<div className="d-flex">
								<Link onClick={openContactformModal} className="agent-number"><i class="icon-people-mail"></i>Email</Link>
								{props.site.Phone ?
									<Link to={whatsapp_link} className="agent-number agent-whatsapp" target="_blank"><i class="whatsapp-icon"></i> WhatsApp</Link>
									:
									<Link to={whatsapp_link} className="agent-number agent-whatsapp" target="_blank" ><i class="whatsapp-icon"></i> WhatsApp</Link>
								}
							</div>
						</div>
					</div>
				}
				{props.peoples && props.timings &&
					<div className="available-timing">
						{HTMLReactParser(props.timings.replace(/<br\s*\/?>/gi, ''))}
					</div>
				}
			</div>
			<ModalTiny show={modalContactformOpen} onHide={closeContactformModal} className="modal-form-wrapper">
                <ModalTiny.Header>
                <div class="modal-close-btn" onClick={closeContactformModal}><CloseIcon /></div>
                    <ModalTiny.Title>
						<h4>Contact</h4>
						<p className="text-sm">The Dacha team is always ready to help and answer any questions. Chat online with our friendly property experts or get in touch using the form below </p>
					</ModalTiny.Title>
                </ModalTiny.Header>
                <ModalTiny.Body>
                    <ContactForm />
                </ModalTiny.Body>
                </ModalTiny>
		</React.Fragment>
	)
}

export default ServiceSidebar